/* ============ EDIT ME: settings ============ */
const CONFIG = {
  whatsapp: "917793904411",          // EDIT ME: WhatsApp number, country code + number, no "+"
  freeShippingAbove: 3000,           // free shipping threshold
  metroRate: 99, restRate: 149,      // shipping rates
  metroPrefixes: ["11","40","41","50","56","60","70","38"] // Delhi Mumbai Pune Hyd Blr Chennai Kolkata Ahd
};

/* ---- Themes & boxes now load from the Shopify theme editor + Giftbox Packaging collection ---- */
function gbbReadJSON(sel){ const el=document.querySelector(sel); if(!el) return null; try{ return JSON.parse(el.textContent); }catch(e){ return null; } }
let THEMES = gbbReadJSON('[data-gbb-themes]') || [{id:"all", name:"All Gifts", img:"\ud83c\udf81"}];
let PACKAGING = gbbReadJSON('[data-gbb-packaging]') || [];

/* ============ EDIT ME: products (step 2) ============
   themes: which theme circles show this item (wedding/corporate/festive/birthday/housewarming)
   sub: subcategory pill shown in step 2
   fit: box types the item physically fits, e.g. fit:["open"] (tall/large items). Omit = fits every box. */
const ITEMS = [
 {id:"it1", themes:["wedding"], sub:"Wedding Stationery", name:"Customisable Invitation Scroll Box", price:399, img:"https://cdn.shopify.com/s/files/1/0846/6812/1386/files/YPK03508.jpg?v=1756449648", desc:"A keepsake scroll box, customised with your invite or note."},
 {id:"it2", themes:["wedding","her"], sub:"Wedding Stationery", name:"Hexagonal Glass Ring Box", price:399, img:"https://cdn.shopify.com/s/files/1/0846/6812/1386/files/YPK03507.jpg?v=1756449647", desc:"Elegant glass ring box for proposals and keepsakes."},
 {id:"it3", themes:["wedding","bridesmaid","her"], sub:"Personalized", name:"Blush Rose Bridesmaid Gift Box", price:399, img:"https://cdn.shopify.com/s/files/1/0846/6812/1386/files/YPK03621.jpg?v=1756449648", desc:"Pre-styled blush box for your bride tribe."},
 {id:"it4", themes:["wedding","groomsmen","him"], sub:"Personalized", name:"Obsidian Noir Groomsmen Gift Box", price:399, img:"https://cdn.shopify.com/s/files/1/0846/6812/1386/files/YPK03639.jpg?v=1756449681", desc:"Sleek black gift box for the groomsmen."},
 {id:"it5", themes:["wedding","festive"], sub:"Craft Souvenirs", name:"Shyamrang Blue Pichwai Tray", price:399, img:"https://cdn.shopify.com/s/files/1/0846/6812/1386/files/YPK02573.jpg?v=1756461397", desc:"Handpainted Pichwai art tray in deep blue."},
 {id:"it6", themes:["wedding","festive"], sub:"Craft Souvenirs", name:"Gulabi Kamal Pink Pichwai Tray", price:399, img:"https://cdn.shopify.com/s/files/1/0846/6812/1386/files/YPK02575.jpg?v=1756403529", desc:"Lotus-motif Pichwai tray in gulabi pink."},
 {id:"it7", themes:["wedding","festive"], sub:"Craft Souvenirs", name:"Ratanjali Red Pichwai Tray", price:399, img:"https://cdn.shopify.com/s/files/1/0846/6812/1386/files/YPK02663.jpg?v=1756400006", desc:"Rich red handpainted Pichwai tray."},
 {id:"it8", themes:["wedding","festive"], sub:"Craft Souvenirs", name:"Pitambar Yellow Pichwai Tray (Large)", price:499, img:"https://cdn.shopify.com/s/files/1/0846/6812/1386/files/YPK00706_1_1.png?v=1757154222", desc:"Large-format yellow Pichwai tray."},
 {id:"it9", themes:["wedding","festive","bridesmaid"], sub:"Craft Souvenirs", name:"Lotus Print Potlis — Set of 10", price:800, img:"https://cdn.shopify.com/s/files/1/0846/6812/1386/files/WhatsAppImage2024-06-17at8.30.26PM_1.png?v=1757154671", desc:"Hand-block lotus print potli bags, set of 10.", variants:{label:"Colour", options:["Green","Pink","Blue","Orange","Red"]}},
 {id:"it10", themes:["corporate","him","farewell"], sub:"Utility Gifts", name:"Self-Stirring Glass Tumbler", price:499, fit:["open"], img:"https://cdn.shopify.com/s/files/1/0846/6812/1386/files/YPK03919_1_1.png?v=1757156205", desc:"Battery-powered self-stirring tumbler."},
 {id:"it11", themes:["corporate","him","farewell"], sub:"Utility Gifts", name:"Leather Mini Glass Tumbler", price:399, img:"https://cdn.shopify.com/s/files/1/0846/6812/1386/files/YPK03491.jpg?v=1756449647", desc:"Glass tumbler in a leather sleeve."},
 {id:"it12", themes:["corporate","wellness","festive","farewell"], sub:"Mithai & Dry Fruits", name:"Artisanal Tea Sampler", price:450, img:"🍵", badge:"Add listing", desc:"Placeholder — create this listing on Shopify, then paste its image URL here."},
 {id:"it13", themes:["wedding","corporate","festive"], sub:"Mithai & Dry Fruits", name:"Dry Fruit Potli", price:550, img:"🥜", badge:"Add listing", desc:"Placeholder — create this listing on Shopify, then paste its image URL here."},
 {id:"it14", themes:["corporate","festive","farewell"], sub:"Mithai & Dry Fruits", name:"Gourmet Cookie Box", price:350, img:"🍪", badge:"Add listing", desc:"Placeholder — create this listing on Shopify, then paste its image URL here."},
 {id:"it15", themes:["wedding","festive"], sub:"Home Decor", name:"Golden Bloom Urli Bowl", price:1249, fit:["open"], img:"https://cdn.shopify.com/s/files/1/0846/6812/1386/files/YPK03580_554db46a-1f76-4457-9cb0-88fad7db83e6.jpg?v=1756403532", desc:"Statement gold urli for florals and festive styling."},
 {id:"it16", themes:["wedding","festive","her"], sub:"Home Decor", name:"Ivory Bloom Urli Bowl", price:795, img:"https://cdn.shopify.com/s/files/1/0846/6812/1386/files/YPK03592.jpg?v=1756449297", desc:"Ivory urli bowl with floral detailing."},
 {id:"it17", themes:["festive"], sub:"Home Decor", name:"Red Handpainted Picchwai Wall Plate", price:1200, fit:["open"], img:"https://cdn.shopify.com/s/files/1/0846/6812/1386/files/YPK02623_a59bad50-56ae-427b-a8d1-268d091c83d0.jpg?v=1756474195", desc:"Handpainted wall plate in Pichwai style."},
 {id:"it18", themes:["wedding","festive","her","wellness"], sub:"Home Decor", name:"Gul Hand Block Table Runner", price:899, img:"https://cdn.shopify.com/s/files/1/0846/6812/1386/files/e6b824c5-41bd-43dc-aa73-0ca40f847aac_1.png?v=1757153523", desc:"Hand-block printed cotton table runner."},
 {id:"it19", themes:["corporate","farewell","her"], sub:"Stationery", name:"Parijat Floral Handblock Journal", price:449, img:"https://cdn.shopify.com/s/files/1/0846/6812/1386/files/YPK03452.jpg?v=1756468508", desc:"Handblock floral cover journal."},
 {id:"it20", themes:["corporate","farewell","her"], sub:"Stationery", name:"Sindoori Handblock Mini Planner", price:349, img:"https://cdn.shopify.com/s/files/1/0846/6812/1386/files/YPK03441.jpg?v=1756466343", desc:"Compact handblock print planner."},
 {id:"it21", themes:["corporate","farewell"], sub:"Stationery", name:"Indigo Ikat A6 Spiral Notepad", price:290, img:"https://cdn.shopify.com/s/files/1/0846/6812/1386/files/467.jpg?v=1771682087", desc:"A6 spiral notepad in indigo ikat."},
 {id:"it23", themes:["corporate","farewell","him"], sub:"Stationery", name:"Charcoal Ikat A6 Fabric Notepad", price:290, img:"https://cdn.shopify.com/s/files/1/0846/6812/1386/files/482.jpg?v=1771681286", desc:"A6 fabric notepad in charcoal ikat."},
 {id:"it24", themes:["corporate","farewell","her"], sub:"Stationery", name:"Blue Floral Block Print A6 Notepad", price:290, img:"https://cdn.shopify.com/s/files/1/0846/6812/1386/files/5ded76da-f102-44a0-9452-5ca3e0245c30.jpg?v=1771686923", desc:"A6 notepad in blue floral block print."},
 {id:"it25", themes:["corporate","farewell","her","festive"], sub:"Stationery", name:"Ruby Paisley A6 Spiral Notepad", price:290, img:"https://cdn.shopify.com/s/files/1/0846/6812/1386/files/462.jpg?v=1771684033", desc:"A6 spiral notepad in ruby paisley."},
 {id:"it26", themes:["corporate","farewell","festive"], sub:"Stationery", name:"Orange Ikat A6 Fabric Notepad", price:290, img:"https://cdn.shopify.com/s/files/1/0846/6812/1386/files/65ee6638-0d72-45ce-97d4-08268fe3c41f.jpg?v=1771686953", desc:"A6 fabric notepad in orange ikat."},
 {id:"it27", themes:["corporate","farewell","her","bridesmaid"], sub:"Stationery", name:"Blush Floral A6 Fabric Notepad", price:290, img:"https://cdn.shopify.com/s/files/1/0846/6812/1386/files/470_905f820c-722e-4fe5-b5c3-cc29d2970b9a.jpg?v=1771684749", desc:"A6 fabric notepad in blush floral."},
 {id:"it28", themes:["corporate","farewell","her"], sub:"Stationery", name:"Coral Ikat A6 Spiral Notepad", price:290, img:"https://cdn.shopify.com/s/files/1/0846/6812/1386/files/477_8cf56de0-4ecc-4662-84ba-3b059637c578.jpg?v=1771684924", desc:"A6 spiral notepad in coral ikat."},
 {id:"it22", themes:["him","corporate","farewell"], sub:"Utility Gifts", name:"Ikat Sunglasses Case (Navy Blue)", price:549, img:"https://cdn.shopify.com/s/files/1/0846/6812/1386/files/YPK03530.jpg?v=1756533653", desc:"Padded ikat sunglasses case."}
];

/* ============ EDIT ME: finishing touches (step 3) ============ */
const ADDONS = [
 {id:"ad1", name:"Greeting Card", price:49, img:"https://cdn.shopify.com/s/files/1/0846/6812/1386/files/E8652AA2-112C-45A0-B463-664358D198721_1.png?v=1756537152", desc:"A printed card with your message, tucked inside.", variants:{label:"Design", options:["Emerald Thank You","B&W Thank You","Birthday Floral","Plain Floral","Watercolor Florals"]}},
 {id:"ad2", name:"Personalized Photo Card", price:149, img:"🖼️", desc:"Your photo + message, printed on a keepsake card."},
 {id:"ad3", name:"Satin Ribbon Wrap", price:99, img:"🎀", desc:"The whole box wrapped and bowed in satin ribbon.", variants:{label:"Colour", options:["Ivory","Blush Pink","Deep Maroon","Gold"]}},
 {id:"ad4", name:"Dried Flower Arrangement", price:249, img:"🌾", desc:"An everlasting dried posy styled into the box."},
 {id:"ad5", name:"Fresh Seasonal Blooms", price:349, img:"💐", desc:"Fresh flowers arranged on dispatch day."},
 {id:"ad6", name:"Name Monogram on Box", price:199, img:"✒️", desc:"Recipient's name hand-lettered on the box.", input:"Recipient's name (max 20 chars)"},
 {id:"ad7", name:"Logo Branding on Box", price:299, img:"🏷️", desc:"Your corporate logo printed on the lid or sleeve."}
];

const DOTS = {"Green":"#5b7a3a","Pink":"#e88ca8","Blue":"#3a5b8f","Orange":"#e07b39","Red":"#b02020","Yellow":"#e8c33a","Maroon":"#6d1a2d","Beige":"#d9c7a7","Black":"#1a1a1a","Purple":"#5e3a72","Cream":"#f5ecd7","Ivory":"#f4efe2","Blush Pink":"#f0c3cc","Deep Maroon":"#6d1a2d","Gold":"#d7bb60"};
const inr = n => "₹" + n.toFixed(2) + " INR";
const $ = s => document.querySelector(s);
const find = (arr,id) => arr.find(x=>x.id===id);
const imgOf = p => /^(http|\/\/)/.test(p.img) ? `<img src="${p.img}" alt="${p.name}" loading="lazy">` : p.img;

let state = {step:1, theme:"all", pack:null, items:{}, addons:{}, msg:"", pin:"", shipping:null, sub:"All", sort:"", q:"", qty:1};
let savedBoxes = []; // curated giftboxes already added to the cart
let modalSel = {variant:null, qty:1, text:""};

function subtotal(){
  let s = 0;
  if(state.pack) s += find(PACKAGING,state.pack.id).price;
  for(const k in state.items) s += find(ITEMS,k.split("|")[0]).price * state.items[k];
  for(const id in state.addons) s += find(ADDONS,id).price;
  return s;
}
function savedTotal(){ return savedBoxes.reduce((t,b)=> t + b.sub*b.qty, 0); }
function orderSubtotal(){ return savedTotal() + subtotal()*state.qty; }
function shippingFor(pin){
  if(!/^[1-9][0-9]{5}$/.test(pin)) return null;
  if(orderSubtotal() >= CONFIG.freeShippingAbove) return 0;
  return CONFIG.metroPrefixes.includes(pin.slice(0,2)) ? CONFIG.metroRate : CONFIG.restRate;
}
let toastT;
function toast(msg){
  const t = $("#toast"); t.textContent = msg; t.classList.add("show");
  clearTimeout(toastT); toastT = setTimeout(()=>t.classList.remove("show"), 2200);
}
function goto(n){
  state.step = n;
  document.querySelectorAll("#gbb .stepper .st").forEach(b=>{
    const s = +b.dataset.s;
    b.classList.toggle("active", s===n);
    b.classList.toggle("done", s<n);
  });
  $("#backBtn").style.visibility = n===1 ? "hidden" : "visible";
  $("#nextBtn").style.display = n===5 ? "none" : "inline-block";
  renderStage(); renderBar();
  if(n===5) maybeBulkPop();
  document.getElementById("gbb").scrollIntoView({behavior:"smooth"});
}
function gbbBind(){
  document.querySelectorAll("#gbb .stepper .st").forEach(b=> b.onclick = ()=>{ if(canLeave(+b.dataset.s)) goto(+b.dataset.s); });
  $("#backBtn").onclick = ()=> goto(Math.max(1, state.step-1));
  $("#nextBtn").onclick = ()=>{ if(canLeave(state.step+1)) goto(Math.min(5, state.step+1)); };
}
gbbBind();
function canLeave(target){
  if(target===5 && savedBoxes.length && !state.pack && Object.keys(state.items).length===0) return true;
  if(target>1 && !state.pack){ toast("Choose your box first"); return false; }
  if(target>2 && Object.keys(state.items).length===0){ toast("Add at least one gift item"); return false; }
  return true;
}
function boxCard(p){
  const sel = state.pack && state.pack.id===p.id;
  return `<div class="card ${sel?"selected":""}" data-id="${p.id}">
    <span class="inbadge">Selected</span>
    <div class="imgbox">${imgOf(p)}</div>
    <div class="nm">${p.name}</div>
    <div class="pr">${inr(p.price)}</div>
    <button class="addbtn">${sel?"Change":"Add"}</button>
  </div>`;
}
function itemCard(p){
  const q = Object.keys(state.items).filter(k=>k.startsWith(p.id+"|")).reduce((a,k)=>a+state.items[k],0);
  return `<div class="card ${q>0?"inbox":""}" data-id="${p.id}">
    <span class="inbadge">&times;${q} in box</span>
    <div class="imgbox">${imgOf(p)}</div>
    <div class="nm">${p.name}</div>
    <div class="pr">${inr(p.price)}</div>
    <button class="addbtn">Add</button>
  </div>`;
}
function addonCard(p){
  const on = !!state.addons[p.id];
  return `<div class="card ${on?"inbox":""}" data-id="${p.id}">
    <span class="inbadge">Added</span>
    <div class="imgbox">${imgOf(p)}</div>
    <div class="plainname">${p.name}</div>
    <div class="pr">${inr(p.price)}</div>
    <button class="addbtn">${on?"Edit":"Add"}</button>
  </div>`;
}
function renderStage(){
  const S = $("#stage");
  if(state.step===1){
    const boxList = state.theme==="corporate" ? PACKAGING.filter(p=>p.corp) : PACKAGING;
    S.innerHTML = `
      <h2 class="stagehead">Pick a gifting theme</h2>
      <div class="themes">${THEMES.map(t=>`<button class="th ${state.theme===t.id?"on":""}" data-t="${t.id}"><span class="circ">${imgOf(t)}</span><span class="tl">${t.name}</span></button>`).join("")}</div>
      <h2 class="stagehead">Choose your box</h2>
      <p class="themenote">${state.theme==="corporate" ? `Showing <b>corporate</b> boxes only` : `Showing all boxes`} \u00b7 ${boxList.length} options</p>
      <div class="grid boxes">${boxList.map(boxCard).join("")}</div>`;
    S.querySelectorAll(".themes .th").forEach(b=> b.onclick = ()=>{ state.theme=b.dataset.t; state.sub="All"; renderStage(); });
    S.querySelectorAll(".card").forEach(c=> c.onclick = ()=> openModal("pack", c.dataset.id));
  }
  if(state.step===2){
    const tName = (THEMES.find(t=>t.id===state.theme)||{name:"All Gifts"}).name;
    const themed = ITEMS.filter(i=> state.theme==="all" || (i.themes||[]).includes(state.theme));
    const subs = ["All", ...new Set(themed.map(i=>i.sub))];
    if(!subs.includes(state.sub)) state.sub = "All";
    let list = themed.filter(i=> (state.sub==="All"||i.sub===state.sub) && i.name.toLowerCase().includes(state.q.toLowerCase()));
    const packObj = state.pack ? find(PACKAGING,state.pack.id) : null;
    let hidden = 0;
    if(packObj && packObj.fit){ const before = list.length; list = list.filter(i=> !i.fit || i.fit.includes(packObj.fit)); hidden = before - list.length; }
    if(state.sort==="lh") list = [...list].sort((a,b)=>a.price-b.price);
    if(state.sort==="hl") list = [...list].sort((a,b)=>b.price-a.price);
    S.innerHTML = `
      <p class="themenote">Showing gifts for <b>${tName}</b>${packObj?` that fit your <b>${packObj.name}</b>`:""} &middot; <button id="chgTheme">change theme</button>${hidden?`<br><span style="color:#b7144d">${hidden} item${hidden>1?"s":""} hidden &mdash; won&#39;t fit the ${packObj.name}</span>`:""}</p>
      <div class="subpills">${subs.map(s=>`<button class="pill ${s===state.sub?"on":""}" data-s="${s}">${s}</button>`).join("")}</div>
      <div class="toolbar">
        <select id="sortSel">
          <option value="">Sort By Price</option>
          <option value="lh" ${state.sort==="lh"?"selected":""}>Price: Low to High</option>
          <option value="hl" ${state.sort==="hl"?"selected":""}>Price: High to Low</option>
        </select>
        <input id="qInput" placeholder="Search" value="${state.q}">
        <button class="searchbtn" id="qBtn">Search</button>
      </div>
      <div class="countrow">${list.length} Pieces</div>
      <div class="grid">${list.map(itemCard).join("")}</div>`;
    $("#chgTheme").onclick = ()=> goto(1);
    S.querySelectorAll(".subpills .pill").forEach(b=> b.onclick = ()=>{ state.sub=b.dataset.s; renderStage(); });
    $("#sortSel").onchange = e=>{ state.sort=e.target.value; renderStage(); };
    $("#qBtn").onclick = ()=>{ state.q=$("#qInput").value; renderStage(); };
    $("#qInput").addEventListener("keydown", e=>{ if(e.key==="Enter"){ state.q=e.target.value; renderStage(); }});
    S.querySelectorAll(".card").forEach(c=> c.onclick = ()=> openModal("item", c.dataset.id));
  }
  if(state.step===3){
    S.innerHTML = `<div class="grid">${ADDONS.map(addonCard).join("")}</div>
      <p class="stagenote">Cards, ribbons, flowers &amp; personalisation — optional, add as many as you like.</p>`;
    S.querySelectorAll(".card").forEach(c=> c.onclick = ()=> openModal("addon", c.dataset.id));
  }
  if(state.step===4){
    S.innerHTML = `<div class="formcard">
      <label>Gift Card Message</label>
      <textarea id="msg" placeholder="Write the note we should tuck inside...">${state.msg}</textarea>
      <label>Delivery Pincode</label>
      <div class="pinrow"><input id="pin" maxlength="6" inputmode="numeric" placeholder="e.g. 400001" value="${state.pin}"><button class="checkbtn" id="checkPin">Check</button></div>
      <div class="shipmsg" id="shipmsg"></div>
      <div class="shipnote">Free above ${inr(CONFIG.freeShippingAbove)} &middot; Metro ${inr(CONFIG.metroRate)} &middot; Rest of India ${inr(CONFIG.restRate)}</div>
    </div>`;
    $("#msg").oninput = e=> state.msg = e.target.value;
    $("#checkPin").onclick = checkPin;
    $("#pin").addEventListener("keydown", e=>{ if(e.key==="Enter") checkPin(); });
    if(state.pin) checkPin();
  }
  if(state.step===5) renderPreview();
}
function checkPin(){
  state.pin = $("#pin") ? $("#pin").value.trim() : state.pin;
  const sh = shippingFor(state.pin);
  const m = $("#shipmsg");
  if(sh===null){ state.shipping=null; if(m){m.className="shipmsg err"; m.textContent="Please enter a valid 6-digit pincode.";} }
  else { state.shipping=sh; if(m){m.className="shipmsg ok"; m.textContent = sh===0 ? "You've unlocked FREE shipping!" : "Shipping to "+state.pin+": "+inr(sh);} }
  renderBar();
}
function renderPreview(){
  const S = $("#stage");
  const p = state.pack ? find(PACKAGING, state.pack.id) : null;
  let rows = "";
  Object.keys(state.items).forEach(k=>{
    const [id,v] = k.split("|"); const i = find(ITEMS,id); const q = state.items[k];
    rows += `<div class="pvrow"><button class="rm" data-t="item" data-k="${k}">x</button><span class="ti">${imgOf(i)}</span><span class="nm2">${i.name}${v?`<span class="var">${v}</span>`:""}</span><span class="pp">${inr(i.price)}</span><span class="qq">x ${q}</span></div>`;
  });
  Object.keys(state.addons).forEach(id=>{
    const a = find(ADDONS,id); const d = state.addons[id];
    const detail = d.text || (a.variants ? d.choice : "");
    rows += `<div class="pvrow"><button class="rm" data-t="addon" data-k="${id}">x</button><span class="ti">${imgOf(a)}</span><span class="nm2">${a.name}${detail?`<span class="var">${detail}</span>`:""}</span><span class="pp">${inr(a.price)}</span><span class="qq">x 1</span></div>`;
  });
  let info = "";
  if(state.msg) info += `<tr><td>Gift card message:</td><td>${state.msg}</td></tr>`;
  if(state.pin) info += `<tr><td>Delivery pincode:</td><td>${state.pin}</td></tr>`;
  for(const id in state.addons){ const d=state.addons[id]; if(d.text) info += `<tr><td>${find(ADDONS,id).name}:</td><td>${d.text}</td></tr>`; }
  const s = subtotal();
  const shipRow = state.shipping===null
    ? `<div class="trow"><span>Shipping</span><span class="amt" style="color:#8a8468;font-size:12px">enter pincode in step 4</span></div>`
    : `<div class="trow"><span>Shipping (${state.pin})</span><span class="${state.shipping===0?"free":"amt"}">${state.shipping===0?"FREE":inr(state.shipping)}</span></div>`;
  const savedRows = savedBoxes.map((b,ix)=> `<div class="trow"><span>${b.name} &times; ${b.qty}</span><span class="amt">${inr(b.sub*b.qty)} <button class="sbrm" data-i="${ix}" title="Remove giftbox">x</button></span></div>`).join("");
  const grand = s*state.qty + savedTotal() + (state.shipping||0);
  S.innerHTML = `
    <button class="backbtn" id="pvBack">Back</button>
    <div class="preview">
      <div class="pvcard">
        <div class="boxrow">
          <div class="boximg">${p?imgOf(p):"?"}</div>
          <div class="boxmeta">
            <h3>${p?p.name:"No box selected"}${state.pack&&state.pack.variant?`<span class="var">${state.pack.variant}</span>`:""}</h3>
            <span class="pp asul">${p?inr(p.price):""}</span>
            <div class="bactions"><button class="smbtn" id="pvEdit">Edit</button><button class="smbtn" id="pvRemove">Remove</button></div>
          </div>
        </div>
        ${rows || '<div class="pvrow" style="color:#8a8468">No items added yet</div>'}
      </div>
      <div>
        <div class="sidebox"><h3>Additional Information</h3>
          <table><tr><th>Field</th><th>Value</th></tr>${info || '<tr><td colspan="2" style="color:#8a8468">—</td></tr>'}</table>
        </div>
        <div class="sidebox"><h3>Order Details</h3>
          <div class="trow"><span>Giftbox quantity</span><span class="qtyctl"><button id="qMinus">&minus;</button><b>${state.qty}</b><button id="qPlus">+</button></span></div>
          <div class="trow"><span>This giftbox${state.qty>1?` &times; ${state.qty}`:""}</span><span class="amt">${inr(s*state.qty)}</span></div>
          ${savedRows}
          ${shipRow}
          <div class="trow grand"><span>Total</span><span>${inr(grand)}</span></div>
        </div>
        <button class="bigbtn" id="addMore">Add More</button>
        <button class="bigbtn ghost" id="saveBox">Add to cart &amp; build another giftbox</button>
        <button class="bigbtn" id="addCart">Checkout</button>
        <p class="stagenote">We'll confirm your final selection &amp; shipping on the order.</p>
      </div>
    </div>`;
  $("#pvBack").onclick = ()=> goto(4);
  $("#addMore").onclick = ()=> goto(2);
  $("#qMinus").onclick = ()=>{ if(state.qty>1){ state.qty--; renderPreview(); renderBar(); } };
  $("#qPlus").onclick = ()=>{ state.qty++; renderPreview(); renderBar(); };
  $("#saveBox").onclick = ()=>{
    if(!state.pack && !Object.keys(state.items).length){ toast("This giftbox is empty"); return; }
    savedBoxes.push({ name: p ? p.name : "Custom giftbox", qty: state.qty, sub: s, pack: state.pack, items: Object.assign({}, state.items), addons: Object.assign({}, state.addons), msg: state.msg });
    state.pack = null; state.items = {}; state.addons = {}; state.msg = ""; state.qty = 1;
    toast("Giftbox added to cart! Build your next one.");
    goto(1);
  };
  S.querySelectorAll(".sbrm").forEach(b=> b.onclick = ()=>{ savedBoxes.splice(+b.dataset.i,1); renderPreview(); renderBar(); });
  $("#addCart").onclick = ()=> alert("Thank you! Giftbox ordering is launching soon — for now, please reach out on WhatsApp or Instagram @nilahcollective to place this order.");
  $("#pvEdit").onclick = ()=> state.pack && openModal("pack", state.pack.id);
  $("#pvRemove").onclick = ()=>{ state.pack=null; goto(1); };
  S.querySelectorAll(".pvrow .rm").forEach(b=> b.onclick = ()=>{
    if(b.dataset.t==="item") delete state.items[b.dataset.k]; else delete state.addons[b.dataset.k];
    renderPreview(); renderBar();
  });
}
function openModal(kind, id){
  const p = kind==="pack" ? find(PACKAGING,id) : kind==="item" ? find(ITEMS,id) : find(ADDONS,id);
  const existing = kind==="addon" ? state.addons[id] : null;
  const groups = p.opts || (p.variants ? [p.variants] : []);
  modalSel = { sels: groups.map(g=>g.options[0]), qty:1, text: existing?.text || "" };
  if(existing?.choice && groups.length) modalSel.sels[0] = existing.choice;
  if(kind==="pack" && state.pack && state.pack.id===id && state.pack.variant){ const prev = String(state.pack.variant).split(" \u00b7 "); groups.forEach((g,gi)=>{ if(prev[gi] && g.options.includes(prev[gi])) modalSel.sels[gi]=prev[gi]; }); }
  Object.defineProperty(modalSel,"variant",{configurable:true,get(){ return modalSel.sels.length ? modalSel.sels.join(" \u00b7 ") : null; },set(v){ if(modalSel.sels.length) modalSel.sels[0]=v; }});
  const swatches = groups.map((g,gi)=>`<div class="optlbl">Choose ${g.label}</div>
    <div class="swatches swg" data-g="${gi}">${g.options.map(o=>`<button class="sw ${o===modalSel.sels[gi]?"on":""}" data-o="${o}">${DOTS[o]?`<span class="dot" style="background:${DOTS[o]}"></span>`:""}${o}</button>`).join("")}</div>`).join("");
  const input = p.input ? `<div class="optlbl">Personalisation</div><input type="text" id="mtext" maxlength="20" placeholder="${p.input}" value="${modalSel.text}">` : "";
  const qty = kind==="item" ? `<div class="optlbl">Quantity</div><div class="qty"><button id="qm">&minus;</button><span id="qv">1</span><button id="qp">+</button></div>` : "";
  const removeBtn = (kind==="addon" && existing) ? `<button class="mbtn ghost" id="mRem">Remove</button>` : "";
  const addLbl = kind==="pack" ? (state.pack&&state.pack.id===id?"Update":"Add") : (kind==="addon"&&existing?"Update":"Add");
  $("#modal").innerHTML = `
    <button class="close" id="mClose">X</button>
    <div class="mleft">
      <div class="mainimg">${imgOf(p)}</div>
      <div class="thumbstrip"><span class="tt">${imgOf(p)}</span></div>
    </div>
    <div class="mright">
      <div class="eyebrow">Nilah Collective Gifting</div>
      <h3>${p.name}</h3>
      <div class="mprice">${inr(p.price)}</div>
      <div class="mdesc">${p.desc||""}</div>
      ${swatches}${input}${qty}
      <div class="maction"><button class="mbtn" id="mAdd">${addLbl}</button>${removeBtn}</div>
    </div>`;
  $("#overlay").classList.add("open");
  document.querySelectorAll(".swg").forEach(gdiv=>{ const gi=+gdiv.dataset.g; gdiv.querySelectorAll(".sw").forEach(b=> b.onclick = e=>{ e.stopPropagation();
    modalSel.sels[gi] = b.dataset.o;
    gdiv.querySelectorAll(".sw").forEach(x=>x.classList.toggle("on", x===b));
  });});
  if(kind==="item"){
    $("#qm").onclick = ()=>{ if(modalSel.qty>1){modalSel.qty--; $("#qv").textContent=modalSel.qty;} };
    $("#qp").onclick = ()=>{ modalSel.qty++; $("#qv").textContent=modalSel.qty; };
  }
  const mt = $("#mtext"); if(mt) mt.oninput = ()=> modalSel.text = mt.value;
  $("#mClose").onclick = closeModal;
  $("#mAdd").onclick = ()=>{
    if(kind==="pack"){
      state.pack = {id, variant:modalSel.variant};
      const f = find(PACKAGING,id).fit; let removed = 0;
      if(f) Object.keys(state.items).forEach(k=>{ const it = find(ITEMS,k.split("|")[0]); if(it.fit && !it.fit.includes(f)){ delete state.items[k]; removed++; } });
      if(removed) toast(removed+" item(s) removed \u2014 won\u2019t fit this box");
    }
    if(kind==="item"){ const k = id+"|"+(modalSel.variant||""); state.items[k] = (state.items[k]||0)+modalSel.qty; toast("Item added"); }
    if(kind==="addon") state.addons[id] = {choice:modalSel.variant, text:modalSel.text};
    closeModal(); renderStage(); renderBar();
  };
  const mr = $("#mRem"); if(mr) mr.onclick = ()=>{ delete state.addons[id]; closeModal(); renderStage(); renderBar(); };
}
function closeModal(){ $("#overlay").classList.remove("open"); }
$("#overlay").addEventListener("click", e=>{ if(e.target.id==="overlay") closeModal(); });
document.addEventListener("keydown", e=>{ if(e.key==="Escape"){ closeModal(); $("#bulkpop").classList.remove("open"); } });
function renderBar(){
  const T = $("#thumbs");
  let h = "";
  if(state.pack){ const p = find(PACKAGING,state.pack.id);
    h += `<span class="thumb">${imgOf(p)}<span class="q">x1</span><button class="rm" data-t="pack">x</button></span>`; }
  Object.keys(state.items).forEach(k=>{ const i = find(ITEMS,k.split("|")[0]);
    h += `<span class="thumb">${imgOf(i)}<span class="q">x${state.items[k]}</span><button class="rm" data-t="item" data-k="${k}">x</button></span>`; });
  Object.keys(state.addons).forEach(id=>{ const a = find(ADDONS,id);
    h += `<span class="thumb">${imgOf(a)}<span class="q">x1</span><button class="rm" data-t="addon" data-k="${id}">x</button></span>`; });
  const filled = (state.pack?1:0) + Object.keys(state.items).length + Object.keys(state.addons).length;
  for(let i=filled; i<6; i++) h += `<span class="thumb empty"></span>`;
  T.innerHTML = h;
  T.querySelectorAll(".rm").forEach(b=> b.onclick = ()=>{
    if(b.dataset.t==="pack") state.pack=null;
    if(b.dataset.t==="item") delete state.items[b.dataset.k];
    if(b.dataset.t==="addon") delete state.addons[b.dataset.k];
    renderStage(); renderBar();
  });
  const s = orderSubtotal() + (state.shipping && state.step>=4 ? state.shipping : 0);
  $("#barTotal").textContent = inr(s);
}
let bulkShown = false;
function maybeBulkPop(){
  if(bulkShown) return;
  try{ if(sessionStorage.getItem("gbbBulk")==="1") return; }catch(e){}
  if(!state.pack && !Object.keys(state.items).length) return;
  bulkShown = true;
  const bp = $("#bulkpop");
  const dismiss = ()=>{ bp.classList.remove("open"); try{ sessionStorage.setItem("gbbBulk","1"); }catch(e){} };
  $("#bulkClose").onclick = dismiss;
  $("#bulkNo").onclick = dismiss;
  const bx = state.pack ? find(PACKAGING, state.pack.id).name : "a custom giftbox";
  const n = Object.keys(state.items).length;
  const wa = $("#waLink");
  wa.href = "https://wa.me/" + CONFIG.whatsapp + "?text=" + encodeURIComponent("Hi! I would like bulk pricing for my curated giftbox from Nilah Collective: " + bx + " with " + n + " items (" + inr(subtotal()) + " per box).");
  wa.onclick = dismiss;
  bp.onclick = e=>{ if(e.target===bp) dismiss(); };
  setTimeout(()=> bp.classList.add("open"), 600);
}
goto(1);
document.addEventListener("shopify:section:load", function(){
  THEMES = gbbReadJSON('[data-gbb-themes]') || THEMES;
  PACKAGING = gbbReadJSON('[data-gbb-packaging]') || PACKAGING;
  gbbBind(); goto(state.step);
});
